import { Component } from '@angular/core';

@Component({
  selector: 'lib-survey-completed',
  imports: [],
  templateUrl: './survey-completed.html',
  styleUrl: './survey-completed.css',
})
export class SurveyCompleted {

}
